import React from 'react'

import { Container, Row, Col } from 'react-bootstrap';
import { useGetMabroomProductsQuery } from '../../slices/productsApiSlice';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Skeleton from 'react-loading-skeleton';

import Meta from '../../components/Meta';
import ShoppingProduct from '../../components/ShoppingProduct';

const SITE = 'https://tamratdates.com';

const FAQ_AR = [
  { q: 'ما الذي يميّز التمر المبروم؟', a: 'شكله الممدود الرفيع وقوامه شبه الناشف المتماسك القابل للمضغ، ولونه العنبري المائل للبني.' },
  { q: 'هل التمر المبروم طري أم ناشف؟', a: 'هو بين الاثنين؛ شبه ناشف ومتماسك مع طراوة لطيفة، يناسب من يفضّل التمر الأقل ليونة.' },
  { q: 'متى يكون التمر المبروم خياراً جيداً؟', a: 'قضمة طاقة محمولة، ومع القهوة، ولمن يحب القوام المتماسك القابل للمضغ، وكهدية أنيقة.' },
  { q: 'كيف أحفظ التمر المبروم؟', a: 'قوامه المتماسك يجعله أطول في الحفظ نسبياً؛ احفظه في مكان بارد وجاف أو في الثلاجة.' },
];
const FAQ_EN = [
  { q: 'What makes Mabroom distinctive?', a: 'Its long, slender shape and firm, chewy, semi-dry texture, with an amber-to-brown colour.' },
  { q: 'Is Mabroom soft or dry?', a: "It's in between — semi-dry and firm with a pleasant chew, ideal for those who prefer a less-soft date." },
  { q: 'When is Mabroom a good choice?', a: 'As portable energy, with Arabic coffee, for anyone who likes a firm chewy texture, and as an elegant gift.' },
  { q: 'How do I store Mabroom dates?', a: 'Its firm texture keeps relatively well; store in a cool, dry place or refrigerate.' },
];

function MabroomDates() {

  const { t , i18n } = useTranslation();
  const en = i18n.language === 'en';

    const { data, isLoading, error } = useGetMabroomProductsQuery();

  const url = `${SITE}/mabroom-date`;
  const faq = en ? FAQ_EN : FAQ_AR;
  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: en ? 'Home' : 'الرئيسية', item: `${SITE}/` },
        { '@type': 'ListItem', position: 2, name: en ? 'Mabroom Dates' : 'تمر المبروم', item: url },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

    if(isLoading) {
      return(
      <div>
   <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
   <Skeleton width={150} />
   </div>
      <h1 className="title">
         <Skeleton width={150} />
      </h1>
        <Row className="py-5">
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        </Row>
    </div>
      )
    }

  return (
    <div>
      {en ? (
        <>
          <Meta
            title={'Mabroom Dates — Long, Chewy Premium Dates | Tamrat'}
            description={'Buy premium Mabroom dates online from Tamrat — long, slender, semi-dry dates with a firm, satisfying chew. Fast delivery across Saudi Arabia, free over 250 SAR.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>Home</span></Link>
            <FaAngleRight />
            <span style={{color:'#7C9D64'}}>Mabroom Date</span>
          </div>
        </>
      ) : (
        <>
          <Meta
            title={'تمر مبروم فاخر — ممدود ومتماسك | تمرات'}
            description={'اشترِ التمر المبروم الفاخر من تمرات: ممدود الشكل، شبه ناشف ومتماسك بقوام لذيذ قابل للمضغ. توصيل سريع لكل مناطق السعودية وشحن مجاني للطلبات فوق ٢٥٠ ر.س.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>الرئيسية</span></Link>
            <FaAngleLeft />
            <span style={{color:'#7C9D64'}}>تمر المبروم</span>
          </div>
        </>
      )}

      <h1 className="title">{t('mabroomTitle')}</h1>
      <Container>
        <Row className="py-5">
        { error ? (
        <div>{error?.data.message || error.error}</div>
      ) : (
        data.products.map((product) => (
          <Col sm={4} key={product.id} className='mb-4 p-4'>
         <ShoppingProduct product={product} />
        </Col>
         ))
             )}
        </Row>
      </Container>

      <Container className="pb-5" dir={en ? 'ltr' : 'rtl'} style={{ maxWidth: 900, lineHeight: 1.9, color: '#3d3d3d' }}>
        {en ? (
          <div>
            <h2 style={{ color: '#7C9D64' }}>What is Mabroom?</h2>
            <p>Mabroom is a distinctive date known for its <strong>long, slender shape</strong> and firm, chewy, semi-dry texture, with an amber-to-brown colour. Its sweetness is moderate-to-rich, and it suits anyone who prefers a less-soft, more substantial date.</p>
            <h2 style={{ color: '#7C9D64' }}>How to enjoy Mabroom dates</h2>
            <ul>
              <li>As portable energy on the go.</li>
              <li>With Arabic coffee.</li>
              <li>For those who love a firm, chewy bite.</li>
              <li>As an elegant gift.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>Nutrition</h2>
            <p>Mabroom dates are a natural source of energy, fibre and potassium. <em>Values are approximate and vary by size and ripeness; for any specific diet, consult a specialist.</em></p>
            <h2 style={{ color: '#7C9D64' }}>Who it's for</h2>
            <p>For those who prefer a firmer, chewy texture and a natural, portable energy snack.</p>
            <h2 style={{ color: '#7C9D64' }}>Frequently asked questions</h2>
            {FAQ_EN.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        ) : (
          <div>
            <h2 style={{ color: '#7C9D64' }}>ما هو التمر المبروم؟</h2>
            <p>المبروم نوع مميّز يُعرف بـ<strong>شكله الممدود الرفيع</strong> وقوامه شبه الناشف المتماسك القابل للمضغ، ولونه العنبري المائل للبني. حلاوته معتدلة إلى غنية، ويناسب من يفضّل التمر الأقل ليونة والأكثر تماسكاً.</p>
            <h2 style={{ color: '#7C9D64' }}>كيف تستمتع بالتمر المبروم؟</h2>
            <ul>
              <li>قضمة طاقة محمولة أثناء التنقّل.</li>
              <li>مع القهوة العربية.</li>
              <li>لمن يحب القوام المتماسك القابل للمضغ.</li>
              <li>هدية أنيقة.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>القيمة الغذائية</h2>
            <p>التمر المبروم مصدر طبيعي للطاقة والألياف والبوتاسيوم. <em>القيم تقريبية وتختلف حسب الحجم ودرجة النضج؛ ولأي نظام غذائي خاص يُنصح باستشارة مختص.</em></p>
            <h2 style={{ color: '#7C9D64' }}>لمن يناسب؟</h2>
            <p>لمن يفضّل القوام المتماسك القابل للمضغ، ولمن يبحث عن وجبة طاقة طبيعية محمولة.</p>
            <h2 style={{ color: '#7C9D64' }}>الأسئلة الشائعة</h2>
            {FAQ_AR.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        )}
      </Container>
    </div>
  )
}

export default MabroomDates
